/**
 * @generated SignedSource<<9f6426ac6f883d00585082bb5ab7d478>>
 * @relayHash e3f4430f0c6f10abdc30dd47391ac5fe
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e3f4430f0c6f10abdc30dd47391ac5fe

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ClientSubscriptionPlanNid = "BUILD" | "GROW" | "MEMBERS_ONLY" | "SCALE" | "%future added value";
export type OnboardingType = "CLIENT" | "CONTRACTOR" | "%future added value";
export type WorkspaceFeature = "ADVANCED_CONTRACTOR_SEARCH" | "ALLOW_PAYMENT_METHOD_SEPA" | "AUTOMATICALLY_APPROVE_ACH_REQUESTS" | "AUTOMATICALLY_APPROVE_INQUIRIES" | "AUTOMATICALLY_APPROVE_JOB_POSTINGS" | "AUTOMATICALLY_APPROVE_PAID_PROJECT_INVITE" | "BYPASS_COMPLIANT_CONTRACT_PLATFORM_FEES" | "BYPASS_PLATFORM_FEES" | "CLIENT_ACCESS_BASIC_NETWORK" | "CLIENT_ACCESS_NETWORK" | "CLIENT_ANALYTICS" | "CLIENT_COMPLIANT_CONTRACTS" | "CLIENT_CUSTOM_CONTRACTS" | "CLIENT_PUBLISH_NETWORK_LISTS" | "CLIENT_WORKSPACE_DOCUMENT_UPLOAD" | "HAS_ACTIVE_SUBSCRIPTION" | "NO_HOLD_DIRECT_DEBIT_PAYMENTS" | "RESTRICTED_EXPERIENCE" | "SELF_SERVE_SUBSCRIPTION" | "USE_LEDGER_SANDBOX" | "VIEW_CONTRACTOR_COMPLIANCE_DETAILS" | "%future added value";
export type SelectUserTypeInput = {
  userType: OnboardingType;
};
export type useUserTypeSelectorSelectUserTypeMutation$variables = {
  input: SelectUserTypeInput;
  owners?: ReadonlyArray<string> | null;
  type: OnboardingType;
};
export type useUserTypeSelectorSelectUserTypeMutation$data = {
  readonly selectUserType: {
    readonly errors: ReadonlyArray<{
      readonly __typename: string;
      readonly message: string;
    }> | null;
    readonly query: {
      readonly newInAppNotificationCount: number;
    };
    readonly userAccount: {
      readonly id: string;
      readonly selectedUserType: OnboardingType;
      readonly workspaceForSelectedUserType: {
        readonly __typename: string;
        readonly activeSubscription?: {
          readonly nid: ClientSubscriptionPlanNid;
        } | null;
        readonly enabledFeatures: ReadonlyArray<WorkspaceFeature>;
        readonly subscriptions?: ReadonlyArray<{
          readonly nid: ClientSubscriptionPlanNid;
        }>;
      };
      readonly " $fragmentSpreads": FragmentRefs<"NotificationList_fragment" | "UserInfoFragment_userAccount" | "WorkspaceActivePlanCard_workspacePlanSubscription" | "getRollupCardConfig_UserAccount">;
    };
  };
};
export type useUserTypeSelectorSelectUserTypeMutation = {
  response: useUserTypeSelectorSelectUserTypeMutation$data;
  variables: useUserTypeSelectorSelectUserTypeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": ([]/*: any*/),
  "kind": "LocalArgument",
  "name": "owners"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v3 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "selectedUserType",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enabledFeatures",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nid",
  "storageKey": null
},
v9 = [
  (v8/*: any*/)
],
v10 = {
  "kind": "Variable",
  "name": "type",
  "variableName": "type"
},
v11 = {
  "kind": "Literal",
  "name": "pageSize",
  "value": 3
},
v12 = {
  "kind": "Literal",
  "name": "sort",
  "value": {
    "direction": "DESC",
    "field": "CREATED_AT"
  }
},
v13 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "addedBy",
        "variableName": "owners"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  (v11/*: any*/),
  (v12/*: any*/)
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uid",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v19 = [
  (v4/*: any*/),
  (v17/*: any*/),
  (v18/*: any*/)
],
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "ContraImage",
  "kind": "LinkedField",
  "name": "avatarImage",
  "plural": false,
  "selections": (v19/*: any*/),
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "PrivateContactMetadata",
  "kind": "LinkedField",
  "name": "privateContactMetadata",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    (v16/*: any*/),
    (v20/*: any*/)
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayUsername",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "UserProfile",
  "kind": "LinkedField",
  "name": "connectedUserProfile",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v15/*: any*/),
    (v16/*: any*/),
    (v22/*: any*/),
    (v20/*: any*/)
  ],
  "storageKey": null
},
v24 = {
  "kind": "Variable",
  "name": "owners",
  "variableName": "owners"
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v26 = [
  (v14/*: any*/)
],
v27 = {
  "alias": null,
  "args": [
    {
      "fields": [
        (v24/*: any*/),
        {
          "kind": "Literal",
          "name": "statuses",
          "value": [
            "POSTED",
            "PRIVATE",
            "IN_REVIEW",
            "PENDING_REVISION",
            "REJECTED"
          ]
        }
      ],
      "kind": "ObjectValue",
      "name": "filter"
    },
    (v11/*: any*/)
  ],
  "concreteType": "JobPage",
  "kind": "LinkedField",
  "name": "jobs",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Job",
      "kind": "LinkedField",
      "name": "data",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isPosted",
          "storageKey": null
        },
        (v4/*: any*/),
        (v25/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "JobCandidatePage",
          "kind": "LinkedField",
          "name": "candidates",
          "plural": false,
          "selections": (v26/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v28 = {
  "kind": "Literal",
  "name": "first",
  "value": 3
},
v29 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "clientOwners",
        "variableName": "owners"
      },
      {
        "kind": "Literal",
        "name": "statuses",
        "value": [
          "ACTIVE",
          "ON_HOLD",
          "PROPOSAL",
          "PROPOSAL_DECLINED",
          "IN_REVIEW"
        ]
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  (v28/*: any*/),
  (v12/*: any*/)
],
v30 = [
  (v4/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/),
  (v20/*: any*/)
],
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "UserProfile",
  "kind": "LinkedField",
  "name": "clientOwner",
  "plural": false,
  "selections": (v30/*: any*/),
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "PaidProjectContractorParty",
  "kind": "LinkedField",
  "name": "contractor",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProfile",
      "kind": "LinkedField",
      "name": "userProfile",
      "plural": false,
      "selections": (v30/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v33 = [
  (v28/*: any*/),
  (v12/*: any*/)
],
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailAddress",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "UserProfile",
  "kind": "LinkedField",
  "name": "userProfile",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isRemovedFromClientWorkspace",
      "storageKey": null
    },
    (v20/*: any*/),
    (v15/*: any*/),
    (v16/*: any*/),
    (v22/*: any*/)
  ],
  "storageKey": null
},
v36 = [
  (v4/*: any*/)
],
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "Query",
  "kind": "LinkedField",
  "name": "query",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "newInAppNotificationCount",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v39 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currentCycleUsage",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "entitlementPerCycle",
    "storageKey": null
  }
],
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v41 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  (v10/*: any*/)
],
v42 = [
  (v17/*: any*/),
  (v4/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useUserTypeSelectorSelectUserTypeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "SelectUserTypePayload",
        "kind": "LinkedField",
        "name": "selectUserType",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserAccount",
            "kind": "LinkedField",
            "name": "userAccount",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "workspaceForSelectedUserType",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ClientWorkspaceSubscription",
                        "kind": "LinkedField",
                        "name": "activeSubscription",
                        "plural": false,
                        "selections": (v9/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ClientWorkspaceSubscription",
                        "kind": "LinkedField",
                        "name": "subscriptions",
                        "plural": true,
                        "selections": (v9/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "ClientWorkspace",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "args": [
                  (v10/*: any*/)
                ],
                "kind": "FragmentSpread",
                "name": "NotificationList_fragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UserInfoFragment_userAccount"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WorkspaceActivePlanCard_workspacePlanSubscription"
              },
              {
                "kind": "InlineDataFragmentSpread",
                "name": "getRollupCardConfig_UserAccount",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "workspaceForSelectedUserType",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": (v13/*: any*/),
                            "concreteType": "ContactPage",
                            "kind": "LinkedField",
                            "name": "contactsV2",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Contact",
                                "kind": "LinkedField",
                                "name": "data",
                                "plural": true,
                                "selections": [
                                  (v4/*: any*/),
                                  (v21/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UserProfile",
                                    "kind": "LinkedField",
                                    "name": "createdByUserProfile",
                                    "plural": false,
                                    "selections": [
                                      (v15/*: any*/),
                                      (v16/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v23/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v27/*: any*/),
                          {
                            "alias": null,
                            "args": (v29/*: any*/),
                            "concreteType": "WorkspacePaidProjectV2Connection",
                            "kind": "LinkedField",
                            "name": "paidProjectsV2",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "WorkspacePaidProjectV2Edge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v25/*: any*/),
                                      (v31/*: any*/),
                                      (v32/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "ClientWorkspace",
                        "abstractKey": null
                      },
                      {
                        "alias": "workspaceMembers",
                        "args": (v33/*: any*/),
                        "concreteType": "WorkspaceMemberConnection",
                        "kind": "LinkedField",
                        "name": "members",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WorkspaceMemberEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v34/*: any*/),
                                  (v35/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "members(first:3,sort:{\"direction\":\"DESC\",\"field\":\"CREATED_AT\"})"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserProfile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": (v36/*: any*/),
                    "storageKey": null
                  }
                ],
                "args": [
                  (v24/*: any*/)
                ],
                "argumentDefinitions": [
                  {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "owners"
                  }
                ]
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v37/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v38/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "useUserTypeSelectorSelectUserTypeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "SelectUserTypePayload",
        "kind": "LinkedField",
        "name": "selectUserType",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserAccount",
            "kind": "LinkedField",
            "name": "userAccount",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "workspaceForSelectedUserType",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ClientWorkspaceSubscription",
                        "kind": "LinkedField",
                        "name": "activeSubscription",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "discountAmount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "trialRemainingDays",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "currentCycleEndsAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "billingCycle",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "billingPortalUrl",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "cancelAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ClientWorkspaceSubscriptionUsageMeters",
                            "kind": "LinkedField",
                            "name": "usageMeters",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ClientWorkspaceSubscriptionUsageMeter",
                                "kind": "LinkedField",
                                "name": "jobBoosts",
                                "plural": false,
                                "selections": (v39/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ClientWorkspaceSubscriptionUsageMeter",
                                "kind": "LinkedField",
                                "name": "contractFees",
                                "plural": false,
                                "selections": (v39/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ClientWorkspaceSubscription",
                        "kind": "LinkedField",
                        "name": "subscriptions",
                        "plural": true,
                        "selections": [
                          (v8/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WorkspaceMemberConnection",
                        "kind": "LinkedField",
                        "name": "members",
                        "plural": false,
                        "selections": (v26/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ClientSubscriptionPlan",
                        "kind": "LinkedField",
                        "name": "availableSubscriptionPlans",
                        "plural": true,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "monthlyPrice",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "yearlyPrice",
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v13/*: any*/),
                        "concreteType": "ContactPage",
                        "kind": "LinkedField",
                        "name": "contactsV2",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Contact",
                            "kind": "LinkedField",
                            "name": "data",
                            "plural": true,
                            "selections": [
                              (v4/*: any*/),
                              (v21/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserProfile",
                                "kind": "LinkedField",
                                "name": "createdByUserProfile",
                                "plural": false,
                                "selections": [
                                  (v15/*: any*/),
                                  (v16/*: any*/),
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v23/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v27/*: any*/),
                      {
                        "alias": null,
                        "args": (v29/*: any*/),
                        "concreteType": "WorkspacePaidProjectV2Connection",
                        "kind": "LinkedField",
                        "name": "paidProjectsV2",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WorkspacePaidProjectV2Edge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v4/*: any*/),
                                  (v25/*: any*/),
                                  (v31/*: any*/),
                                  (v32/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "ClientWorkspace",
                    "abstractKey": null
                  },
                  (v4/*: any*/),
                  (v40/*: any*/),
                  {
                    "alias": "workspaceMembers",
                    "args": (v33/*: any*/),
                    "concreteType": "WorkspaceMemberConnection",
                    "kind": "LinkedField",
                    "name": "members",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WorkspaceMemberEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v4/*: any*/),
                              (v34/*: any*/),
                              (v35/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "members(first:3,sort:{\"direction\":\"DESC\",\"field\":\"CREATED_AT\"})"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v41/*: any*/),
                "concreteType": "NotificationV2Connection",
                "kind": "LinkedField",
                "name": "notificationsV2",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NotificationV2Edge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NotificationV2",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isSeen",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isRead",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "action",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "seenAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "heading",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "subheading",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "createdAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "type",
                            "storageKey": null
                          },
                          (v18/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContraImage",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": (v19/*: any*/),
                            "storageKey": null
                          },
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v41/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "NotificationList_notificationsV2",
                "kind": "LinkedHandle",
                "name": "notificationsV2"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserProfile",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organization",
                    "kind": "LinkedField",
                    "name": "organizationV2",
                    "plural": false,
                    "selections": [
                      (v40/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContraImage",
                        "kind": "LinkedField",
                        "name": "logoImage",
                        "plural": false,
                        "selections": (v42/*: any*/),
                        "storageKey": null
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v15/*: any*/),
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContraImage",
                    "kind": "LinkedField",
                    "name": "avatarImage",
                    "plural": false,
                    "selections": (v42/*: any*/),
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v37/*: any*/),
              (v6/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v36/*: any*/),
                "type": "CollaboratorNotFoundError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v36/*: any*/),
                "type": "CollaboratorRoleCountInvalidError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v36/*: any*/),
                "type": "OrganizationNotFoundError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v36/*: any*/),
                "type": "ProductizedServiceCollaboratorNotFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v36/*: any*/),
                "type": "ReferBasicOpportunityUserNotFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v36/*: any*/),
                "type": "SubmitJoinOrganizationRequestError",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          (v38/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "e3f4430f0c6f10abdc30dd47391ac5fe",
    "metadata": {},
    "name": "useUserTypeSelectorSelectUserTypeMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "7dfdb522ee210d77355b829fd781f450";

export default node;
